import { render, staticRenderFns } from "./NewsListWidget.vue?vue&type=template&id=5e160026&scoped=true&"
import script from "./NewsListWidget.vue?vue&type=script&lang=js&"
export * from "./NewsListWidget.vue?vue&type=script&lang=js&"
import style0 from "./NewsListWidget.vue?vue&type=style&index=0&id=5e160026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e160026",
  null
  
)

export default component.exports